import React from 'react';
import Group from '@bubble-ui/primitive-group';
import Shape from '@bubble-ui/primitive-shape';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';

var FlagSE = function FlagSE() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Group, {
    id: "sweden"
  }, /*#__PURE__*/React.createElement(Shape, {
    d: "M178.755624,75 C171.614453,32.4342982 134.594947,0 90,0 C79.480937,0 69.3833673,1.80462645 59.9999996,5.12117078 L60,5.12116698 L59.9999998,75 L178.755624,75 L178.755624,75 Z M178.755624,105 C171.614453,147.565702 134.594947,180 90,180 C79.480937,180 69.3833673,178.195374 59.9999996,174.878829 L59.9999997,105 L178.755624,105 L178.755624,105 Z M1.24437643,75 C4.69435516,54.4360378 15.1178273,36.2367078 30,22.916803 L30,22.916803 L30,75 L1.24437643,75 L1.24437643,75 Z M1.24437643,105 C4.69435516,125.563962 15.1178273,143.763292 30,157.083197 L30,105 L1.24437643,105 L1.24437643,105 Z",
    id: "blue",
    fill: "#227FBB"
  }), /*#__PURE__*/React.createElement(Shape, {
    d: "M30,75 L30,22.916803 C38.6564375,15.1690819 48.8214053,9.07223656 59.9999996,5.12117078 L60,5.12116698 L59.9999998,75 L178.755624,75 C179.574018,79.8781271 180,84.8893168 180,90 C180,95.1106832 179.574018,100.121873 178.755624,105 L59.9999998,105 L59.9999996,174.878829 C48.8214054,170.927763 38.6564376,164.830918 30,157.083197 L30,105 L1.24437643,105 C0.425981881,100.121873 0,95.1106832 0,90 C0,84.8893168 0.425981881,79.8781271 1.24437643,75 L30,75 L30,75 Z",
    id: "yellow",
    fill: "#F2C500"
  })));
};

FlagSE.displayName = 'FlagSE';
export default withFlagWrapper(FlagSE);
//# sourceMappingURL=index.js.map